function handleSubmission(submitButton, state, text) {
    if (state === "enable") {
        submitButton.classList.remove('--disabled');
        submitButton.disabled = false;
        submitButton.innerHTML = text;
    } else if (state === "disable") {
        // Disable button and show spinner
        submitButton.classList.add('--disabled');
        submitButton.disabled = true;
        submitButton.innerHTML = text + '<span class="spinner"></span>';
    }
}

function showNotificationPopup(message, type, popupId) {
    // Remove any existing notification
    var mainNotification = document.querySelector(popupId + ' .popup_notification.active');
    if (mainNotification) {
        mainNotification.classList.remove('active');
    }

    // Add new notification
    var notification = document.querySelector(popupId + ' .popup_notification');
    notification.textContent = message;
    notification.classList.add('active');
    notification.classList.add('--' + type);

    // Remove the active class and type class after 3 seconds
    setTimeout(function () {
        notification.classList.remove('active');
        notification.classList.remove('--' + type);
    }, 3000);
}

function showModalNotification(message, type) {
    // Remove any existing notification
    var modalNotification = jQuery('.mj-modal-notification.active');
    modalNotification.removeClass('active');

    // Add new notification
    var notification = jQuery('.mj-modal-notification');
    notification.text(message).addClass('active');
    notification.addClass('--' + type);

    // Remove the active class and type class after 3 seconds
    setTimeout(function () {
        notification.removeClass('active');
        notification.removeClass('--' + type);
    }, 4000);
}

function loadPopup(popupID) {
    //get this element.
    // if this element exist.
    //1. loop through all elements with jupiterx-popup class and add jupiterx-popup--hide-state (if they don't have) and also remove jupiterx-popup--show-state if they have such a class
    //2. go and fine the parent of that popupID element which has jupiterx-popup class and remove jupiterx-popup--hide-state and add jupiterx-popup-show-state to it.
    // var popupID = event.currentTarget.id.substring(triggerPrefix.length);
    // Use jQuery to find the closest ancestor with class 'mj-popup__hide'
    var popupSelector = jQuery('#' + popupID).closest('.jupiterx-popup')[0];

    console.log(popupSelector);
    if (popupSelector) {
        // Use jQuery to manipulate the classes
        jQuery(popupSelector).removeClass('mj-popup__hide');
        jQuery(popupSelector).removeClass('jupiterx-popup--hide-state');
        jQuery(popupSelector).addClass('jupiterx-popup--show-state');
    } else {
        //console.error("Popup element not found!");
    }
}

function site_url_wpml(global = false) {
    // Get the current path and split it into parts
    var currentPath = window.location.pathname.split('/').filter(Boolean); // Remove empty elements

    // Get the first part of the path, which could be the language code
    var langCode = currentPath[0]; // Assume the first element is the language code

    // Define supported languages
    var supportedLanguages = ['ie', 'ae']; // Supported languages: ie, ae

    // If global is true, bypass the language code and return the main URL
    if (global) {
        langCode = ''; // Ignore the language code if global is true
    } else {
        // Check if the detected langCode is one of the supported languages
        if (!supportedLanguages.includes(langCode)) {
            langCode = ''; // If no valid language code is found, default to no prefix
        }
    }

    // Build the base URL (protocol + host)
    var baseUrl = window.location.protocol + "//" + window.location.host + "/";

    // Append language code to the URL if it's not bypassed and is supported
    if (langCode) {
        baseUrl += langCode + "/"; // Add the language code to the base URL
    }

    // Return the final site URL
    return baseUrl;
}

function sanitizeFileName(fileName) {
    // Remove unwanted characters (keep alphanumerics, dashes, periods for extensions)
    var sanitized = fileName
        .trim() // Remove leading/trailing spaces
        .replace(/\s+/g, '-') // Replace spaces with dashes
        .replace(/_/g, '-') // Replace underscores with dashes
        .replace(/[`~!@#$%^&*()+=\[\]{};:'"\\|,<>/?]+/g, '') // Remove unwanted characters
        .toLowerCase(); // Optional: Convert to lowercase for consistency

    return sanitized;
}